import scrollLock from 'scroll-lock';
import debounce from 'lodash.debounce';
import { scrollPageTo, getSiblings } from '../utils';

export default class StoryOverview {
	constructor(header) {
		// DOM elements
		this.header = header;
		this.storyOverview = document.querySelector('[data-c-story-overview]');
		this.searchInput = this.storyOverview.querySelector('input[name="q"]');
		this.loadMoreButton = this.storyOverview.querySelector('[data-load-more-cats]');
		this.searchForm = this.storyOverview.querySelector('form');

		this.storiesElm = document.querySelector('[data-c-story-overview-stories]');

		// State
		this.breakpoint = window.matchMedia('(max-width:575px)');
		this.isActive = false;
		this.openend = 0;

		// Close when entering new page
		document.addEventListener('bless', ({ detail }) => {
			this.isActive && this.close();
		});

		document.addEventListener('close-overview', () => {
			this.isActive && this.close();
		});

		// Search from event listeners
		this.searchForm.addEventListener('submit', e => {
			this.search(e);

			if (this.breakpoint.matches === true) {
				this.searchInput.blur();
			}

			e.preventDefault();
		});

		this.searchForm.addEventListener(
			'change',
			debounce(e => this.search(e), 400),
		);

		this.searchInput.addEventListener(
			'keyup',
			debounce(e => this.search(e), 400),
		);

		document.addEventListener('click', e => {
			const target = e.target;

			if (target.closest('[data-story-overview]')) {
				this.setFilters([target.dataset.storyOverview]);
				this.open(true);

				e.preventDefault();
				e.stopPropagation();

				if (this.breakpoint.matches === true) {
					this.loadMoreCats();
				}
			}

			if (target.closest('[data-toggle-stories]')) {
				this.isActive ? this.close() : this.open();
			}
		});

		// Event listeners for mobile
		this.loadMoreButton.addEventListener('click', e => {
			this.loadMoreCats();
		});

		this.breakpoint.addListener(() => this.changeSearchPlaceholder());

		this.changeSearchPlaceholder();
	}

	loadMoreCats() {
		const siblings = getSiblings(this.loadMoreButton);

		this.loadMoreButton.style.display = 'none';
		siblings.forEach(sibling => (sibling.style.display = 'inline-flex'));
	}

	setFilters(filters = []) {
		this.resetForm();

		filters.forEach(filter => {
			this.searchForm.querySelector(`[value="${filter}"]`).checked = true;
		});
	}

	resetForm() {
		this.searchForm.reset();
	}

	search(e) {
		if (!this.isActive) {
			return;
		}

		this.storyOverview.classList.add('is-loading');
		this.storiesElm.scrollTop = 0;

		fetch(this.searchForm.action, {
			method: 'POST',
			headers: {
				Accept: 'application/json',
			},
			body: new FormData(this.searchForm),
		})
			.then(response => response.json())
			.then(data => this.displayStories(data))
			.catch(error => {
				console.error('Error:', error);
			})
			.finally(() => {
				document.dispatchEvent(new CustomEvent('bless-search-results'));

				this.storyOverview.classList.remove('is-loading');

				if (this.searchInput.value) {
					this.storyOverview.classList.add('is-searching');
				} else {
					this.storyOverview.classList.remove('is-searching');
				}
			});
	}

	displayStories(data) {
		this.storiesElm.innerHTML = data.html;
	}

	changeSearchPlaceholder() {
		if (this.breakpoint.matches === true) {
			this.searchInput.placeholder = this.searchInput.dataset.placeholderMobile;
		} else {
			this.searchInput.placeholder = this.searchInput.dataset.placeholderDesktop;
		}
	}

	open(search = false) {
		this.scrollDown().then(() => {
			this.storyOverview.scrollTop = 0;
			this.storyOverview.classList.add('is-active');
			this.storyOverview.classList.add('is-open');

			this.header.stick();

			document.body.classList.add('has-story-overview-openend');
			document.body.classList.add('has-story-overview-opening');
			this.isActive = true;
			scrollLock.disablePageScroll(this.storiesElm);
			this.changeTriggerText();

			if (!this.openend || search) {
				this.search();
			}
			this.openend++;

			this.storyOverview.focus();
		});
	}

	close() {
		const self = this;
		this.storyOverview.classList.remove('is-active');
		this.header.checkScroll();

		let animatingElm = this.storyOverview;
		if (this.breakpoint.matches !== true) {
			animatingElm = self.storyOverview.querySelector('.c-story-overview__container');
		}

		animatingElm.addEventListener(
			'transitionend',
			() => {
				this.storyOverview.classList.remove('is-open');
				document.body.classList.remove('has-story-overview-opening');
			},
			{
				once: true,
			},
		);
		document.body.classList.remove('has-story-overview-openend');
		this.isActive = false;
		scrollLock.enablePageScroll(this.storiesElm);
		this.changeTriggerText();

		const closeEvent = new CustomEvent('close-menu');
		document.dispatchEvent(closeEvent);
	}

	changeTriggerText(trigger) {
		document.querySelectorAll('[data-toggle-stories]').forEach(button => {
			if (!(button.dataset.originalText && button.dataset.toggleText)) {
				return;
			}

			if (this.isActive) {
				button.textContent = button.dataset.toggleText;
			} else {
				button.textContent = button.dataset.originalText;
			}
		});
	}

	scrollDown() {
		if (document.body.classList.contains('has-scrolled')) {
			return new Promise(resolve => resolve()); // Immediately resolve
		}

		// Don't scroll down if not homepage
		let home = document.querySelector('[data-barba-namespace="home"]');
		if (!home) {
			return new Promise(resolve => resolve()); // Immediately resolve
		}

		return scrollPageTo(81, 300); // Returns a promise
	}
}
